import { useDispatch } from "react-redux";
import {
  cleanToken,
  sendToken,
} from "@/redux/actions/token";
import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";
import { changeGlobalState } from "@/redux/actions/global";
import helpers from "@/utils/helpers";

const ERROR_STATE = 4;

export const usePaymentService = () => {

  const dispatch = useDispatch();

  const getToken = async (data) => {
    try {
      dispatch(cleanToken());
      const response = await HTTP_REQUEST.AmplifyApi({
        name: "APIS_SESSION",
        path: url.pagoSession,
        data: {
          body: {
            payload: data,
          },
        },
      });

      const session = response?.payload?.sesion;

      if (session?.token) {
        dispatch(sendToken(session.token));
      } else {
        dispatch(changeGlobalState(ERROR_STATE));
      }
    } catch (error) {
      dispatch(changeGlobalState(ERROR_STATE));
      helpers.sendTagError(error, url.pagoSession);
    }
  };

  return {
    getToken,
  }
};